import {
    Box,
    Button,
    CloseButton,
    Container,
    Dialog,
    Field,
    Input,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { useState } from "react";

import { usePostFormMutation } from "@/hooks/microservicesApi";
import { emailRegex } from "@/utilities/text/regex";

const PopupCita = ({ isOpen, onClose, fecha, hora, tipo, id, hubspotForm, urlDev }) => {
    const [nombre, setNombre] = useState(null);
    const [apellidos, setApellidos] = useState(null);
    const [telefono, setTelefono] = useState(null);
    const [email, setEmail] = useState(null);
    const [telefonoError, setTelefonoError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [postForm] = usePostFormMutation();
    const isBetweenBaseAndMd = useBreakpointValue({ base: true, md: false });

    const nombreError = nombre === "";
    const apellidoError = apellidos === "";

    const router = useRouter();

    const handleSubmit = () => {
        let data_send = {
            id: hubspotForm,
            body: {
                fields: [
                    {
                        name: "firstname",
                        value: nombre,
                    },
                    {
                        name: "lastname",
                        value: apellidos,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "phone",
                        value: telefono,
                    },
                    {
                        name: "wiggot",
                        value: id || urlDev,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx",
                    pageName: "Grupo Guia | " + tipo + " " + id,
                },
            },
        };

        postForm(data_send)
            .then((data_w) => {
                onClose();
                router.push("/desarrollos/thankyoupage-agenda-cita");
            })
            .catch((error) => {
                console.error("Error: ", error);
            });
    };

    return (
        <>
            <Dialog.Root
                open={isOpen}
                placement="center"
                onOpenChange={() => onClose()}
                preventScroll
            >
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content bg="#f8f8f8" p={5}>
                        <Dialog.Header />
                        <Dialog.CloseTrigger asChild zIndex="modal">
                            <CloseButton />
                        </Dialog.CloseTrigger>
                        <Dialog.Body>
                            <Stack direction="column">
                                <Container alignSelf="center" textAlign="center">
                                    <Text fontWeight="700" fontSize="lg" mb={2} color="black">
                                        Quiero saber más
                                    </Text>
                                    {isBetweenBaseAndMd && (
                                        <Text
                                            fontWeight="500"
                                            fontSize="xs"
                                            mb={2}
                                            color="black"
                                            textAlign="left"
                                        ></Text>
                                    )}
                                </Container>
                            </Stack>
                            <Stack direction="column" mt={6}>
                                <Container
                                    alignSelf="center"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            handleSubmit();
                                        }}
                                    >
                                        <Field.Root invalid={nombreError} marginTop="8" required>
                                            <Input
                                                rounded="full"
                                                px="4"
                                                borderWidth={1}
                                                borderColor="gray.200"
                                                focusBorderColor="gray.200"
                                                errorBorderColor="red.500"
                                                id="nombres"
                                                placeholder="Nombre(s) *"
                                                type="text"
                                                color="black"
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setNombre(e.target.value);
                                                }}
                                                onBlur={(e) => {
                                                    e.preventDefault();
                                                    setNombre(e.target.value);
                                                }}
                                            />
                                            {nombreError && (
                                                <Field.ErrorText ml="4" color="red.500">
                                                    El nombre es necesario
                                                </Field.ErrorText>
                                            )}
                                        </Field.Root>
                                        <Field.Root invalid={apellidoError} mt="5" required>
                                            <Input
                                                rounded="full"
                                                px="4"
                                                borderWidth={1}
                                                color="black"
                                                borderColor="gray.200"
                                                focusBorderColor="gray.200"
                                                errorBorderColor="red.500"
                                                id="apellidos"
                                                placeholder="Apellidos(s) *"
                                                type="text"
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setApellidos(e.target.value);
                                                }}
                                                onBlur={(e) => {
                                                    e.preventDefault();
                                                    setApellidos(e.target.value);
                                                }}
                                            />
                                            {apellidoError && (
                                                <Field.ErrorText ml="4" color="red.500">
                                                    El apellido es necesario
                                                </Field.ErrorText>
                                            )}
                                        </Field.Root>
                                        <Field.Root mt="5" invalid={telefonoError} gap={0} required>
                                            <Input
                                                onInvalid={() => setTelefonoError(true)}
                                                rounded="full"
                                                px="4"
                                                borderWidth={1}
                                                color="black"
                                                borderColor="gray.200"
                                                focusBorderColor="gray.200"
                                                errorBorderColor="red.500"
                                                type="number"
                                                id="telefono"
                                                placeholder="Teléfono *"
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setTelefono(e.target.value);
                                                }}
                                                onBlur={(e) => {
                                                    e.preventDefault();
                                                    setTelefono(e.target.value);
                                                    if (e.target.value.trim() === "") {
                                                        setTelefonoError(true);
                                                    } else {
                                                        setTelefonoError(false);
                                                    }
                                                }}
                                            />
                                            {telefonoError && (
                                                <Field.ErrorText ml="4" color="red.500">
                                                    El teléfono no es válido
                                                </Field.ErrorText>
                                            )}
                                        </Field.Root>
                                        <Field.Root mt="5" invalid={emailError} gap={0} required>
                                            <Input
                                                onInvalid={() => setEmailError(true)}
                                                rounded="full"
                                                px="4"
                                                borderWidth={1}
                                                color="black"
                                                borderColor="gray.200"
                                                focusBorderColor="gray.200"
                                                errorBorderColor="red.500"
                                                type="email"
                                                id="email"
                                                placeholder="Correo electrónico *"
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setEmail(e.target.value);
                                                    setEmailError(!emailRegex.test(e.target.value));
                                                }}
                                                onBlur={(e) => {
                                                    e.preventDefault();
                                                    setEmail(e.target.value);
                                                    if (!emailRegex.test(e.target.value)) {
                                                        setEmailError(true);
                                                    } else {
                                                        setEmailError(false);
                                                    }
                                                }}
                                            />
                                            {emailError && (
                                                <Field.ErrorText ml="4" color="red.500">
                                                    La dirección de correo no es válida
                                                </Field.ErrorText>
                                            )}
                                        </Field.Root>
                                        <Box w="100%" justifyContent="center" display="flex" mt="5">
                                            <Button
                                                mt="5"
                                                paddingLeft="10"
                                                paddingRight="10"
                                                rounded="full"
                                                //w='100%'
                                                fill="true"
                                                fontWeight="500"
                                                color="black"
                                                _hover={{
                                                    bg: "#EDBE00",
                                                }}
                                                type="submit"
                                                disabled={
                                                    !nombreError &&
                                                    !apellidoError &&
                                                    !telefonoError &&
                                                    !emailError
                                                        ? false
                                                        : true
                                                }
                                                bg="brand.500"
                                            >
                                                Enviar
                                            </Button>
                                        </Box>
                                    </form>
                                </Container>
                            </Stack>
                        </Dialog.Body>
                        <Dialog.Footer />
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
        </>
    );
};

export default PopupCita;
